let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}



class slideShow extends HTMLElement {   
  constructor() {
    super();
    this.slider = this.querySelector('[data-swiper-options]');
    this.init();
  }

  init() {
    const predefine = {
      effect: 'slide',
      direction: 'horizontal',
      autoplay: true,
      autoplaySpeed: 5,
      space: 0,
      center: true,
      options: {},
    };    
    const slider_options = this.slider.getAttribute('data-swiper-options');
    
    if (slider_options === null || slider_options === '') {
      return null;
    }
    const optionSet = $.extend(true, predefine, JSON.parse(slider_options));
    const isNumberic = /^\d+$/;
    Object.keys(optionSet).forEach((key) => {
      if (typeof optionSet[key] === 'string' && isNumberic.test(optionSet[key])) {
        optionSet[key] = parseInt(optionSet[key], 10);
      }
    });
    const option = $.extend(true, {
     slidesPerView: 1,
      slidesPerColumn: 1,
      init: false,
      spaceBetween: 0,
      loop: true,
      autoplay: {
      delay: 3000,
      },
      speed: 900,
      // navigation: {
      //   nextEl: this.slider.querySelector('.swiper-button-next'),
      //   prevEl: this.slider.querySelector('.swiper-button-prev'),
      // },
      pagination: {
        el: this.slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      //lazy: true,
      // effect: 'fade',
      //  fadeEffect: {
      //       crossFade: true
      //   },      
    }, optionSet.options);
    const Container = this.slider.querySelector('[data-swiper-container]');
    const swiperCall = new Swiper(Container, option);
    swiperCall.on('init', () => {
      swiperCall.update();
    });
    swiperCall.init();
  }
}

customElements.define('slideshow-swiper', slideShow);